import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Text as GrommetText } from 'grommet';

class Text extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    type: 'main',
  };

  render() {
    const { className, type, ...rest } = this.props;
    return <GrommetText {...rest} className={className} type={type} />;
  }
}

export default styled(Text)``;
